/**
 * Actions you can make on product
 * @module  {Actions} productActions
 */
export const UPDATE_PRODUCT = '@@product/UPDATE'

/**
 * Updates the product info
 *
 * @param {Object} product      The updated product
 * @return {Function}           Dispatches an UPDATE_PRODUCT action
 */
export const updateProduct = product => (dispatch, getState) => {
  const { routing } = getState()

  return dispatch({
    type: UPDATE_PRODUCT,
    product,
    flow: routing.flow
  })
}



// WEBPACK FOOTER //
// ./state/actions/productActions.js